// Frais ajoutés à une facture d'achat (consignes, transport, autres) et
// colonnes du fournisseur qui disent s'ils sont taxés. Miroir de
// App\Constants\PurchasesCharges::supplierTaxColumns() côté API.
//
// TPS et TVQ sont stockées séparément mais toujours appliquées ensemble (seuls
// des groupes TPS-TVQ existent) : le formulaire fournisseur écrit les deux
// colonnes à partir d'une seule case.
export const PURCHASES_CHARGES = [
  {
    key: "deposit",
    labelKey: "PURCHASES_ORDERS.DEPOSITS",
    taxColumns: ["purchase_deposit_taxes_tps", "purchase_deposit_taxes_tvq"],
  },
  {
    key: "transportation",
    labelKey: "PURCHASES_ORDERS.TRANSPORTATION_FEES",
    taxColumns: [
      "purchase_transportation_taxes_tps",
      "purchase_transportation_taxes_tvq",
    ],
  },
  {
    key: "other",
    labelKey: "PURCHASES_ORDERS.OTHER_CHARGES",
    taxColumns: ["purchase_other_taxes_tps", "purchase_other_taxes_tvq"],
  },
];

/**
 * Le frais est-il taxé pour ce fournisseur ? Se fie d'abord à
 * `charges_tax_policy`, calculé par l'API exactement comme à la génération de
 * la facture ; à défaut (fournisseur en cours d'édition), lit les colonnes.
 */
export function supplierChargeIsTaxable(supplier, charge) {
  const policy = supplier?.charges_tax_policy;
  if (policy && charge.key in policy) {
    return !!policy[charge.key];
  }

  return charge.taxColumns.some((column) => !!supplier?.[column]);
}
